import { styled } from "@mui/material/styles";
import { Link, LinkProps } from "react-router-dom";

interface NavLinkProps extends Omit<LinkProps, "to"> {
  to: string;
  active?: boolean;
  children: React.ReactNode;
}

const StyledNavLink = styled(Link, {
  shouldForwardProp: (prop) => prop !== 'isActive',
})<{ isActive?: boolean }>(({ isActive }) => ({
  color: isActive ? "var(--brand-primary)" : "var(--text-primary)",
  fontSize: "16px",
  fontWeight: 400,
  lineHeight: "19px",
  padding: "12px",
  textTransform: "none",
  textDecoration: "none",
  fontFamily: "var(--font-family)",
  display: "inline-block",
  position: "relative",
  transition: "color 0.2s ease, font-weight 0.2s ease",

  "&:hover": {
   textDecoration: "underline",
  },
}));

export const NavLink = ({ to, active, children, ...props }: NavLinkProps) => {
  return (
    <StyledNavLink to={to} isActive={active} {...props}>
      {children}
    </StyledNavLink>
  );
};
